import { render } from "./SortedActionButtons.vue?vue&type=template&id=52bab04c"
import script from "./SortedActionButtons.vue?vue&type=script&lang=js"
export * from "./SortedActionButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__